import DefaultDialogController from 'utils/notifications/default-dialog-controller';

const URL_DEFAULT_VALUE = 'http://';

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class UploadBannerController extends DefaultDialogController {
  constructor() {
    super();

    this.urlPattern = new RegExp(`^${this.urlPattern}$`);
    this.urlPatternError = this.urlPatternError.find(
      (urlPatternError) => urlPatternError.code === this.language,
    );

    if (this.publishBannerData) {
      this.fileData = [this.publishBannerData.image];
    } else {
      this.resetForm();
    }
  }

  save(form) {
    if (!form.uploadBannerUrl.$touched) {
      form.uploadBannerUrl.$setValidity('pattern', true);
    }

    form.$setSubmitted();

    if (form.$valid && !this.fileErrors) {
      this.confirm({
        url: this.publishBannerData.url,
        isNew: this.publishBannerData.isNew,
        image: this.fileData[0],
      });
    }
  }

  resetForm() {
    this.publishBannerData = {
      url: URL_DEFAULT_VALUE,
      isNew: true,
    };
  }
}

export default UploadBannerController;



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/banners/components/upload-banner-dialog/upload-banner-dialog-controller.js